export default __webpack_public_path__ + "static/media/place_your_token.d3aa4752.webm";